export const PAYMENTS = Object.freeze({
    PAYMENT_METHODS:{
        GIFTCARD: {TEXT: "Gift Card", VALUE: "giftcard"}
    },
    PAYMENTS:{ 
      SOURCE:'In-store'
    }
  });
  